module.exports = __webpack_public_path__ + "media/fr_ca_s2_Fabien.0e55aeb3.mp3";